import { mapGetters, mapActions, mapMutations } from 'vuex';

import { hasPermission } from '~/helpers/permission';

export default {
  computed: {
    ...mapGetters({
      getterContent         : 'plataforma/newContent/getterContent',
      userPermissions       : 'plataforma/courses/userPermissions',
      getterUserRoleContext : 'plataforma/user/getterUserContext'
    }),
    isModule() {
      return this.getterContent.topics && Array.isArray(this.getterContent.topics);
    },
    isModuleNotEmpty() {
      return this.isModule && !!this.getterContent.topics.length;
    },
    computedTopicsList() {
      if (this.isModule) {
        const topics = JSON.parse(JSON.stringify(this.getterContent.topics));
        return topics;
      }
      return [];
    },
    contentIsUnavailable() {
      const areAllTopicsBlockedByLicense = this.computedTopicsList.length
        && this.computedTopicsList.every(topic => topic.isBlockedContentByLicense);

      return areAllTopicsBlockedByLicense;
    },
    showSelectContentTypeInRender() {
      return this.getterUserRoleContext.isPublisher
        && this.getterContent
        && this.getterContent.context
        && this.getterContent.context.academicMainId
        && this.getterContent.context.academicMainTypeId
        && this.isModule
        && !this.isModuleNotEmpty
        && !this.contentIsUnavailable;
    }
  },
  methods: {
    ...mapActions({
      actionPatchReorderTopic: 'plataforma/newContent/actionPatchReorderTopic'
    }),
    ...mapMutations({
      SET_IS_CURRENT_VIEWER: 'plataforma/newContent/SET_IS_CURRENT_VIEWER'
    }),
    changeTopicsOrderInMenu(topic, isToEmitScrollEvent = false) {
      const params = {
        academicMainId : this.$route.params.courseId,
        topic          : {
          ...topic.moved.element,
          id: topic.moved.element.id
        },
        newSequence   : topic.moved.newIndex,
        oldSequence   : topic.moved.oldIndex,
        version       : this.getterContent.context.version,
        parentTopicId : topic.moved.element.parentTopicId
      };
      this.$nuxt.$loading.start();
      this.actionPatchReorderTopic(params)
        .then(() => {
          if (isToEmitScrollEvent) {
            this.$emit('scroll-selected-topic', params.topic.id);
          } else {
            this.scrollToTopic(params.topic);
          }
          this.SET_IS_CURRENT_VIEWER(params.topic.id);
          this.$toast.success(this.$t('content.successMessagesSnackbar.changeSequence'));
        }).catch((err) => {
          this.$toast.error(err.data.error.message);
        }).finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    scrollToTopic(topic) {
      const elementOffsetTop = document.getElementById(topic.id);
      if (elementOffsetTop) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.toggleNavigationDrawer();
        }
        window.scrollTo({
          top      : elementOffsetTop.offsetTop - 64,
          behavior : 'smooth'
        });
      }
    },
    haveAliasPermissionOnContent(alias) {
      if (!this.getterContent.context) {
        return false;
      };

      return hasPermission(
        this.getterContent.context.academicMainId,
        this.getterContent.context.academicMainTypeId,
        this.getterContent.context.isMarketplace,
        this.getterContent.context.topicTypeId,
        alias,
        this.userPermissions
      );
    }
  }
};
